import React from 'react'
import styles from './style.module.scss'

export const Title = ({ children }) => {
	return <h2 className={styles.title}>{children}</h2>
}
